/**
 * Profile status indicator (§4.2 derived status, §11.1 row badges, PRD micro-states).
 *
 * Redesign: a colored dot plus plain grey text (redesign § Table behavior) — color carries meaning
 * only. The variant keys off the server-derived `status` discriminant — the client never infers a
 * status from runs, timestamps or errors (§12.5 rule 5).
 */

import type { ProfileStatus } from '@lw/shared';
import { cx } from './cx';

const STATUS_LABEL: Record<ProfileStatus, string> = {
  never_scraped: 'Never scraped',
  idle: 'Idle',
  queued: 'Queued',
  scraping: 'Scraping',
  error: 'Error',
  mapper_error: 'Mapper error',
};

export type BadgeProps = {
  status: ProfileStatus;
  /** Hover text — the homescreen passes `lastError` for the `error` status (PRD). */
  title?: string;
  className?: string;
};

export function Badge({ status, title, className }: BadgeProps) {
  return (
    <span className={cx('status', `status--${status}`, className)} title={title}>
      <span className="status__dot" aria-hidden="true" />
      {STATUS_LABEL[status]}
    </span>
  );
}

export default Badge;
